"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KlarnaMerchandising;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _useKlarnaData = require("./use-klarna-data");
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "core-w1pl73lx"
});
const KlarnaImg = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "KlarnaImg",
  class: "core-k1m6fzoh",
  vars: {
    "k1m6fzoh-0": [({
      isSmallText
    }) => isSmallText ? '1.25rem' : '1.5rem'],
    "k1m6fzoh-1": [({
      isSmallText
    }) => isSmallText ? '2.5rem' : '3rem']
  }
});
const ImpressionImg = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "ImpressionImg",
  class: "core-i1qokv12"
});
const Description = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Description",
  class: "core-dyghvla",
  vars: {
    "dyghvla-0": [({
      isSmallText
    }) => isSmallText ? '.875rem' : 'inherit']
  }
});
const LearnMoreLink = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "LearnMoreLink",
  class: "core-lilerrz",
  vars: {
    "lilerrz-0": [({
      isSmallText
    }) => isSmallText ? '.875rem' : 'inherit']
  }
});
function KlarnaMerchandising({
  eids = {
    learnMoreClick: 'eid.learn-more.click'
  },
  price,
  channel = 'web',
  onError = () => {},
  logoUrl,
  hideLogo = false,
  isSmallText = false,
  placementKey = 'credit-promotion-badge',
  paymentConfigUrl
}) {
  (0, _react.useEffect)(() => {
    if (eids?.loadImpression) {
      (0, _patternLibraryUtils.logImpression)(eids.loadImpression);
    }
  }, [eids]);
  const purchaseAmount = price / 10000;
  const {
    data,
    error
  } = (0, _useKlarnaData.useKlarnaData)({
    channel,
    placementKey,
    purchaseAmount,
    paymentConfigUrl
  });
  if (error) {
    onError?.(error);
  }
  return data ? /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "klarna-merchandising",
    className: "fs-unmask"
  }, /*#__PURE__*/_react.default.createElement(Description, {
    "data-cy": "description",
    isSmallText: isSmallText
  }, data.klarnaDescription), !hideLogo && /*#__PURE__*/_react.default.createElement(KlarnaImg, {
    "data-cy": "image",
    isSmallText: isSmallText,
    alt: data.klarnaAltText,
    src: logoUrl || data.klarnaImage
  }), /*#__PURE__*/_react.default.createElement(LearnMoreLink, {
    "data-cy": "learn-more",
    isSmallText: isSmallText,
    href: data.learnMoreUrl,
    target: "_blank",
    rel: "noreferrer",
    "data-eid": eids.learnMoreClick || ''
  }, data.learnMoreText), /*#__PURE__*/_react.default.createElement(ImpressionImg, {
    "data-cy": "impression",
    alt: data.klarnaAltText,
    src: data.klarnaImpression
  }), " ") : null;
}
KlarnaMerchandising.propTypes = {
  channel: _propTypes.default.string,
  eids: _propTypes.default.object,
  hideLogo: _propTypes.default.bool,
  isSmallText: _propTypes.default.bool,
  onError: _propTypes.default.func,
  paymentConfigUrl: _propTypes.default.string,
  placementKey: _propTypes.default.string,
  price: _propTypes.default.number.isRequired,
  logoUrl: _propTypes.default.string
};